import { type ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx'
import { icon, type IconVariants } from './Icon.css'

type IconProps = {
  /** Material Symbols icon name (snake_case, e.g., "arrow_forward") */
  name: string
} & IconVariants &
  Omit<ComponentPropsWithoutRef<'span'>, 'children'>

/**
 * Icon component using Material Symbols (variable icon font).
 *
 * @example
 * <Icon name="home" />
 * <Icon name="favorite" fill />
 * <Icon name="settings" size="lg" />
 *
 * @see https://fonts.google.com/icons for icon names
 */
export function Icon({
  name,
  size,
  fill,
  className,
  'aria-hidden': ariaHidden = true,
  ...props
}: IconProps) {
  return (
    <span
      className={clsx(icon({ size, fill }), className)}
      aria-hidden={ariaHidden}
      {...props}
    >
      {name}
    </span>
  )
}
